import {
   PAYMENT,PAYMENT_FAILURE, PAYMENT_SUCCESS
  } from "../../constants/constants.js";
  
  const initialState = {
    message: "",
    error: null,
    payment: {},
  };
  
  const PaymentReducer = (state = initialState, action) => {
    switch (action.type) {
      case PAYMENT:
        return {
          ...state,
        };
      case PAYMENT_SUCCESS:
        return {
          ...state,
          payment: action?.payload?.data,
          message: action?.payload?.message,
          error: null,
        };
      case PAYMENT_FAILURE:
        return {
          ...state,
          message: action?.payload?.message,
          error: action.payload,
        };
      default:
        return state;
    }
  };
  
  export default PaymentReducer;
  